import React, { useState } from 'react';
import { PhoneBox, TextBoxLayoutStyle } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const PhoneBoxPanel: React.FC = () => {
    const [phone, set_phone] = useState('');

    return (
        <>
            <h6 style={sectionHeaderStyle}>Phone Components:</h6>
            <div style={{ marginBottom: '1rem' }}>
                <PhoneBox
                    id='phoneBox'
                    value={phone}
                    onChange={set_phone}
                    label='Phone Number'
                    required={true}
                    width='100%'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <PhoneBox
                    id='phoneBox'
                    value={phone}
                    onChange={set_phone}
                    label='Phone Number'
                    required={true}
                    width='100%'
                    showInfoIcon={true}
                    infoText='Phone Number Input'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <PhoneBox
                    id='phoneBox'
                    value={phone}
                    onChange={set_phone}
                    label='Phone Number (Horiz.)'
                    required={true}
                    width='100%'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='160px'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <PhoneBox
                    id='phoneBox'
                    value={phone}
                    onChange={set_phone}
                    label='Phone Number (Horiz.)'
                    required={true}
                    width='100%'
                    showInfoIcon={true}
                    infoText='Phone Number Input'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='190px'
                />
            </div>
        </>
    );
};
